const LOAD_DATA_MINI_ENGLISH           = 'LOAD_DATA_MINI_ENGLISH'
const LOAD_DATA_MINI_ENGLISH_SUCCESS   = 'LOAD_DATA_MINI_ENGLISH_SUCCESS'
const LOAD_DATA_MINI_ENGLISH_FAILED    = 'LOAD_DATA_MINI_ENGLISH_FAILED'
const UNMOUNT_DATA_MINI_ENGLISH        = 'UNMOUNT_DATA_MINI_ENGLISH'

const initialState = {
  loading: true,
  data: null,
  message: null,
  pagination: {
    page: 1,
    total: 0,
    perpage: 10
  }
}

const miniEnglishReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MINI_ENGLISH:
      return {
        ...state,
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case LOAD_DATA_MINI_ENGLISH_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        pagination: {
          total: action.payload.pagination.total,
          page: action.payload.pagination.page,
          perpage: action.payload.pagination.perpage
        }
      }
    case LOAD_DATA_MINI_ENGLISH_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case UNMOUNT_DATA_MINI_ENGLISH:
      return { 
        ...state, 
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    default:
      return state
  }
}

export default miniEnglishReducer;